module.exports = {"id":"234048","name":"Eric Ocansey","rating":"71","photo":"./data/images/photos/0/234048.png","club":{"name":"KAS Eupen","logo":"./data/images/clubs/KASEupen.png"},"positions":["MD","MG","AD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EricOcansey0.json
// module id = 1275
// module chunks = 0